import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    all: string;
    unread: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Filter label for all notifications */
            all: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationsListFilter.all?c=3pgdetk0ulcug", defaultMessage: "All" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Filter label for unread notifications only */
            unread: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationsListFilter.unread?c=h7ayxg9kzqmn", defaultMessage: "Unread" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
